module.exports = __webpack_public_path__ + "static/img/PrestationFemme.537518e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PrestationFemme.jpg
// module id = N00J
// module chunks = 1